<template>
   <main>

      <!-- breadcrumb-area-start -->
      <div class="it-breadcrumb-area it-breadcrumb-bg"
         :style="{ backgroundImage: 'url(/img/breadcrumb/breadcrumb.png)' }">
         <div class="container">
            <div class="row ">
               <div class="col-md-12">
                  <div class="it-breadcrumb-content z-index-3 text-center">
                     <div class="it-breadcrumb-title-box">
                        <h3 class="it-breadcrumb-title">about us</h3>
                     </div>
                     <div class="it-breadcrumb-list-wrap">
                        <div class="it-breadcrumb-list">
                           <span><a href="#">home</a></span>
                           <span class="dvdr">//</span>
                           <span>about us</span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- breadcrumb-area-end -->

      <!-- about-area-start -->
      <div class="it-about-4-area  inner-about-style pt-120 pb-120">
         <div class="container">
            <div class="row align-items-center">
               <div class="col-xl-6 col-lg-6">
                  <div
                     class="it-about-4-thumb-wrap d-flex align-items-center justify-content-center justify-content-lg-end">
                     <div class="it-about-4-thumb-double d-flex flex-column">
                        <img class="mb-20" src="/img/about/abt_1.png" alt="">
                        <img src="/img/about/abt_2.png" alt="">
                     </div>
                     <div class="it-about-4-thumb-single">
                        <img src="/img/about/abt_3.png" alt="">
                     </div>
                  </div>
               </div>
               <div class="col-xl-6 col-lg-6">
                  <div class="it-about-3-title-box">
                     <span class="it-section-subtitle">
                        <img src="/img/category/inner.svg" alt="">
                        about us
                     </span>
                     <h2 class="it-section-title-3 pb-30">Quality courses to support your
                        <span>learning</span>
                     </h2>
                     <p>Achievers Institute of Management & Entrepreneurship is a dynamic and forward-thinking
                        institution dedicated to
                        deliver world-class Management & Entrepreneurship education. It is an extended version of
                        Achievers College of
                        Commerce and Management, an ISO Certified Institution established in 2013 affiliated to
                        University of Mumbai which
                        offers nine UG and three PG programmes, along with Ph.D. in Commerce recognized by the UGC. As a
                        newly founded
                        MMS/MBA college, we are committed towards fostering innovation, leadership, and excellence in
                        business education,
                        and to nurture the next generation of managers, entrepreneurs, innovators, and change makers.
                        Located in heart of
                        Kalyan City, Achievers College aspires to become a centre for academic excellence and a trusted
                        partner in shaping the
                        business leaders of tomorrow..</p>
                  </div>
                  <div class="it-about-3-mv-box" style="display: none;">
                     <div class="row">
                        <div class="col-xl-12">
                           <div class="it-about-4-list-wrap d-flex align-items-start">
                              <div class="it-about-4-list-icon">
                                 <span><i class="flaticon-video-1"></i></span>
                              </div>
                              <div class="it-about-3-mv-item">
                                 <span class="it-about-3-mv-title">Sharing a Screen</span>
                                 <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    tempor incididunt ut labore et dolore magna aliqua.</p>
                              </div>
                           </div>
                        </div>
                        <div class="col-xl-12">
                           <div class="it-about-4-list-wrap d-flex align-items-start">
                              <div class="it-about-4-list-icon">
                                 <span><i class="flaticon-puzzle"></i></span>
                              </div>
                              <div class="it-about-3-mv-item">
                                 <span class="it-about-3-mv-title">presenter Control</span>
                                 <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    tempor incididunt ut labore et dolore magna aliqua.</p>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="it-about-3-btn-box p-relative">
                     <router-link class="it-btn" to="/contact">
                        <span>
                           Contact Now
                           <svg width="17" height="14" viewBox="0 0 17 14" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path d="M11 1.24023L16 7.24023L11 13.2402" stroke="currentcolor" stroke-width="1.5"
                                 stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M1 7.24023H16" stroke="currentcolor" stroke-width="1.5" stroke-miterlimit="10"
                                 stroke-linecap="round" stroke-linejoin="round" />
                           </svg>
                        </span>
                     </router-link>
                     <div class="it-about-3-left-shape-3 d-none d-xl-block">
                        <img src="/img/about/about-3-shap-3.png" alt="">
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- about-area-end -->

      <!-- feature-area-start -->
      <div class="it-feature-area grey-bg it-feature-2-style pt-120 pb-120">
         <div class="container">
            <div class="row">
               <div class="col-xl-4 col-lg-4 col-md-6 mb-30">
                  <div class="it-feature-item text-center">
                     <div class="it-feature-item-content z-index">
                        <div class="it-feature-icon">
                           <span><i class="flaticon-class"></i></span>
                        </div>
                        <div class="it-feature-text pt-30">
                           <h4 class="it-feature-title">VISION</h4>
                           <p>Our vision is to nurture future achievers by delivering innovative education that empowers
                              individuals to realize their full potential. We believe in fostering a learning
                              environment that encourages creativity, critical thinking, and continuous growth.</p>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-4 col-lg-4 col-md-6 mb-30">
                  <div class="it-feature-item text-center">
                     <div class="it-feature-item-content z-index">
                        <div class="it-feature-icon">
                           <span><i class="flaticon-bachelor"></i></span>
                        </div>
                        <div class="it-feature-text pt-30">
                           <h4 class="it-feature-title">MISSION</h4>
                           <p>Our mission is to nurture future achievers by providing innovative education that inspires
                              creativity, critical thinking, and problem-solving skills. We aim to equip students with
                              the knowledge and values necessary to drive positive change in society.</p>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-xl-4 col-lg-4 col-md-6 mb-30">
                  <div class="it-feature-item text-center">
                     <div class="it-feature-item-content z-index">
                        <div class="it-feature-icon">
                           <span><i class="flaticon-study"></i></span>
                        </div>
                        <div class="it-feature-text pt-30">
                           <h4 class="it-feature-title">CORE VALUES</h4>
                           <div>
                              <p>Encouragement</p>
                              <p>Honesty and Integrity</p>
                              <p>Accountablity and Responsiblity</p>
                              <p>Student Learning and Development</p>
                              <p>Leadership and Humanitarian Approach</p>
                              <p>Continueous Improvement for Better Change</p>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- feature-area-end -->

      <!-- funfact-area-start -->
      <div class="it-funfact-area z-index-5">
         <div class="container">
            <div class="it-funfact-bg-wrap theme-bg" data-background="/img/funfact/funfact-bg.png">
               <div class="row gx-0">
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                     <div class="it-funfact-item d-flex align-items-center">
                        <div class="it-funfact-icon">
                           <span><i class="flaticon-teacher"></i></span>
                        </div>
                        <div class="it-funfact-content">
                           <h6><i class="purecounter" data-purecounter-duration="1" data-purecounter-end="3">20</i>+
                           </h6>
                           <span>Experience Faculties</span>
                        </div>
                     </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                     <div class="it-funfact-item d-flex align-items-center">
                        <div class="it-funfact-icon">
                           <span><i class="flaticon-completed-task"></i></span>
                        </div>
                        <div class="it-funfact-content">
                           <h6><i class="purecounter" data-purecounter-duration="1" data-purecounter-end="15">30</i>+
                           </h6>
                           <span>Industry Tie-ups</span>
                        </div>
                     </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                     <div class="it-funfact-item d-flex align-items-center">
                        <div class="it-funfact-icon">
                           <span><i class="flaticon-customer-review"></i></span>
                        </div>
                        <div class="it-funfact-content">
                           <h6><i class="purecounter" data-purecounter-duration="1" data-purecounter-end="97"></i>97%
                           </h6>
                           <span>Satisfaction Rate</span>
                        </div>
                     </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                     <div class="it-funfact-item d-flex align-items-center">
                        <div class="it-funfact-icon">
                           <span><i class="flaticon-class"></i></span>
                        </div>
                        <div class="it-funfact-content">
                           <h6><i class="purecounter" data-purecounter-duration="1" data-purecounter-end="102"></i>10+
                           </h6>
                           <span>Certification Offered</span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- funfact-area-end -->

      <!-- testimonial-area-start -->
      <div class="it-testimonial-area it-testimonial-ptb it-sub-bg-none it-testimonial-bg fix p-relative"
         :style="{ backgroundImage: 'url(/img/testimonial/testimonial-bg.jpg)' }">
         <div class="it-testimonial-shape-1 d-none d-xl-block">
            <img src="/img/testimonial/shape-2-1.png" alt="">
         </div>
         <div class="container">
            <div class="it-testimonial-title-wrap mb-60">
               <div class="row align-items-end">
                  <div class="col-xl-6 col-lg-8 col-md-9 col-sm-8">
                     <div class="it-testimonial-title-box">
                        <span class="it-section-subtitle">
                           <img src="/img/category/inner.svg" alt="">
                           testimonial
                        </span>
                        <h4 class="it-section-title">Creating A Community Of Life Long
                           <span class="p-relative z-index">Learners. </span>
                        </h4>
                     </div>
                  </div>
                  <div class="col-xl-6 col-lg-4 col-md-3 col-sm-4">
                     <div class="it-testimonial-arrow text-end"></div>
                  </div>
               </div>
            </div>
            <div class="row">
               <div class="col-xl-12">
                  <div class="it-testimonial-slide-wrap p-relative">
                     <div class="it-testimonial-slide-quote d-none d-xl-block">
                        <i class="fa-sharp fa-solid fa-quote-right"></i>
                     </div>
                     <div class="row align-items-center">
                        <div class="col-xl-2 col-lg-2 col-md-3">
                           <div class="it-testimonial-slide-nav-active text-center">
                              <div class="it-testimonial-nav-item">
                                 <div class="it-testimonial-nav-thumb">
                                    <img src="/img/avatar/avatar-1.png" alt="">
                                 </div>
                              </div>
                              <div class="it-testimonial-nav-item">
                                 <div class="it-testimonial-nav-thumb">
                                    <img src="/img/avatar/avatar-1.png" alt="">
                                 </div>
                              </div>
                              <div class="it-testimonial-nav-item">
                                 <div class="it-testimonial-nav-thumb">
                                    <img src="/img/avatar/avatar-1.png" alt="">
                                 </div>
                              </div>
                              <div class="it-testimonial-nav-item">
                                 <div class="it-testimonial-nav-thumb">
                                    <img src="/img/avatar/avatar-1.png" alt="">
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="col-xl-9 col-lg-9 col-md-9">
                           <div class="it-testimonial-slide-active">
                              <div class="it-testimonial-slide-item">
                                 <div class="it-testimonial-slide-info">
                                    <h4 class="it-testimonial-user-name">Sophia D'souza</h4>
                                    <span>Faulty</span>
                                    <p>Teaching at this MBA program has been an immensely rewarding experience. The
                                       dynamic curriculum, combined with a diverse and motivated student body, creates
                                       an environment where innovation and critical thinking thrive. Our students are
                                       not only eager to learn but also bring real-world perspectives that enrich
                                       classroom discussions. I am proud to be part of a faculty team dedicated to
                                       nurturing future business leaders equipped with the skills, ethical grounding,
                                       and global mindset necessary to excel in today’s fast-paced and ever-changing
                                       business landscape.</p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- testimonial-area-end -->
   </main>
</template>
<script>
export default {
   name: "AboutCollegeView"
};
</script>
